// ═══════════════════════════════════════════════════════════════
//  PhotoSwipe — Premium lightbox for Alaya Junior product gallery
// ═══════════════════════════════════════════════════════════════

function initPhotoSwipe() {
  if (typeof window.PhotoSwipe === 'undefined') return;

  const galleryRoot = document.querySelector('[id^="Slider-Gallery-"]');
  if (!galleryRoot) return;

  // ── Patch ModalOpener buttons ──────────────────────────────
  // Clone each button to remove Dawn's native modal-opener listener,
  // then attach our PhotoSwipe handler instead.
  galleryRoot.querySelectorAll('li[data-media-id] .product__modal-opener--image').forEach((opener) => {
    const btn = opener.querySelector('button');
    if (!btn) return;
    const newBtn = btn.cloneNode(true);
    btn.replaceWith(newBtn);

    newBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openGallery(galleryRoot, opener.closest('li[data-media-id]'));
    });
  });

  // Capture-phase backup for dynamically-added openers
  galleryRoot.addEventListener('click', (e) => {
    const opener = e.target.closest('.product__modal-opener--image');
    if (!opener) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openGallery(galleryRoot, opener.closest('li[data-media-id]'));
  }, true);

  buildDotIndicators(galleryRoot);
}

// ── Open PhotoSwipe ──────────────────────────────────────────

function openGallery(galleryRoot, activeSlide) {
  const slides = Array.from(galleryRoot.querySelectorAll('li[data-media-id]'));
  const index = activeSlide ? Math.max(0, slides.indexOf(activeSlide)) : 0;

  const items = slides.map((s) => {
    const container = s.querySelector('[data-pswp-src]');
    const img = s.querySelector('img');
    if (!container) return null;
    return {
      src:    container.getAttribute('data-pswp-src'),
      width:  Number(container.getAttribute('data-pswp-width'))  || 1024,
      height: Number(container.getAttribute('data-pswp-height')) || 1024,
      alt:    img ? (img.getAttribute('alt') || '') : '',
      msrc:   img ? img.currentSrc || img.src : '',
    };
  }).filter(Boolean);

  if (!items.length) return;

  const isMobile = window.innerWidth < 750;

  const pswp = new window.PhotoSwipe({
    dataSource: items,
    index,
    showHideAnimationType: 'fade',
    bgOpacity: 1,
    wheelToZoom: true,
    pinchToClose: true,
    closeOnVerticalDrag: true,
    padding: isMobile
      ? { top: 0, bottom: 0, left: 0, right: 0 }
      : { top: 40, bottom: 40, left: 60, right: 60 },
    closeTitle: 'Close',
    zoomTitle: 'Zoom in',
    arrowPrevTitle: 'Previous image',
    arrowNextTitle: 'Next image',
    arrowKeys: true,
    imageClickAction: 'zoom',
    tapAction: 'zoom',
    doubleTapAction: 'zoom',
    preload: [1, 2],
  });

  // ── Lock page when lightbox is open ──
  let closedByBackButton = false;

  pswp.on('openingAnimationStart', () => {
    document.documentElement.classList.add('pswp-is-open');
    // Push a history entry so the browser back button closes the lightbox
    // instead of navigating away from the product page
    history.pushState({ pswpOpen: true }, '');
  });

  // Listen for browser back button
  function onPopState(e) {
    if (pswp && pswp.isOpen) {
      closedByBackButton = true;
      pswp.close();
    }
  }
  window.addEventListener('popstate', onPopState);

  pswp.on('closingAnimationEnd', () => {
    document.documentElement.classList.remove('pswp-is-open');
  });

  pswp.on('close', () => {
    window.removeEventListener('popstate', onPopState);
    // If closed via X button or swipe (not back button), remove the extra history entry
    if (!closedByBackButton) {
      history.back();
    }
  });

  // ── Custom UI: dot pagination + swipe hint ──
  let dotsEl = null;
  let hintEl = null;
  let zoomHintEl = null;

  pswp.on('uiRegister', () => {
    // Dot pagination (mobile)
    if (items.length > 1) {
      pswp.ui.registerElement({
        name: 'lightbox-dots',
        className: 'pswp__dots pswp__hide-on-close',
        appendTo: 'wrapper',
        onInit: (el) => {
          dotsEl = el;
          items.forEach((_, i) => {
            const dot = document.createElement('button');
            dot.className = 'pswp__dot' + (i === index ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
            dot.addEventListener('click', () => pswp.goTo(i));
            el.appendChild(dot);
          });
        },
      });
    }

    // Swipe hint (mobile, first visit only)
    if (isMobile && items.length > 1 && !sessionStorage.getItem('pswp-hint-shown')) {
      pswp.ui.registerElement({
        name: 'swipe-hint',
        className: 'pswp__swipe-hint pswp__hide-on-close',
        appendTo: 'wrapper',
        onInit: (el) => {
          hintEl = el;
          el.innerHTML = '<svg viewBox="0 0 24 24"><path d="M13 17l5-5-5-5M6 17l5-5-5-5"/></svg>Swipe to browse';
          sessionStorage.setItem('pswp-hint-shown', '1');
        },
      });
    }
  });

  // Sync dot active state on slide change
  pswp.on('change', () => {
    if (!dotsEl) return;
    const dots = dotsEl.querySelectorAll('.pswp__dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === pswp.currIndex);
    });
  });

  // Brief zoom hint on double tap (mobile)
  if (isMobile) {
    let zoomHintTimeout;
    pswp.on('openingAnimationEnd', () => {
      // Only show the zoom hint once per session
      if (sessionStorage.getItem('pswp-zoom-hint')) return;
      zoomHintEl = document.createElement('div');
      zoomHintEl.className = 'pswp__zoom-hint';
      zoomHintEl.textContent = 'Double tap to zoom';
      pswp.element.appendChild(zoomHintEl);
      requestAnimationFrame(() => zoomHintEl.classList.add('is-visible'));
      zoomHintTimeout = setTimeout(() => {
        zoomHintEl.classList.remove('is-visible');
        setTimeout(() => zoomHintEl.remove(), 300);
      }, 2200);
      sessionStorage.setItem('pswp-zoom-hint', '1');
    });
    pswp.on('close', () => {
      clearTimeout(zoomHintTimeout);
      if (zoomHintEl) zoomHintEl.remove();
    });
  }

  pswp.init();
}

// ── Init ─────────────────────────────────────────────────────
// Script is deferred, so DOM is parsed. Guard for edge cases.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPhotoSwipe);
} else {
  initPhotoSwipe();
}

// ═══════════════════════════════════════════════════════════════
//  Mobile gallery dot indicators (product page, outside lightbox)
// ═══════════════════════════════════════════════════════════════

function buildDotIndicators(galleryRoot) {
  const slides = galleryRoot.querySelectorAll('li[data-media-id]');
  if (slides.length <= 1) return;

  const dotsWrapper = document.querySelector('.gallery-dots-mobile');
  if (!dotsWrapper) return;

  dotsWrapper.innerHTML = '';
  slides.forEach((_, i) => {
    const dot = document.createElement('span');
    dot.className = 'gallery-dot' + (i === 0 ? ' is-active' : '');
    dotsWrapper.appendChild(dot);
  });

  const viewer = document.querySelector('[id^="GalleryViewer-"]');
  if (viewer) {
    viewer.addEventListener('slideChanged', (e) => {
      const activeId = e.detail && e.detail.currentElement && e.detail.currentElement.dataset.mediaId;
      if (!activeId) return;
      const allSlides = Array.from(galleryRoot.querySelectorAll('li[data-media-id]'));
      const idx = allSlides.findIndex((s) => s.dataset.mediaId === activeId);
      if (idx >= 0) setActiveDot(dotsWrapper, idx);
    });
  }

  const observer = new MutationObserver(() => {
    const allSlides = Array.from(galleryRoot.querySelectorAll('li[data-media-id]'));
    const active = allSlides.find((s) => s.classList.contains('is-active'));
    if (!active) return;
    const idx = allSlides.indexOf(active);
    if (idx >= 0) setActiveDot(dotsWrapper, idx);
  });
  observer.observe(galleryRoot, { subtree: true, attributeFilter: ['class'] });
}

function setActiveDot(wrapper, index) {
  wrapper.querySelectorAll('.gallery-dot').forEach((dot, i) => {
    dot.classList.toggle('is-active', i === index);
  });
}
